webpackJsonp([256360735588706],{

/***/ 1454:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---press-a0e39f21c11f6a62c5ab.js